/**
 * Reads the theme chosen in the portal.
 *
 * The portal writes a `portal_theme` cookie on .eigentrage.com, so every
 * dashboard shows the same theme without its own toggle or localStorage key.
 * Absent cookie means dark: that is the estate default, and it avoids a flash
 * of light before the cookie is read.
 */
export function getPortalTheme() {
  const m = document.cookie.match(/(?:^|;\s*)portal_theme=(dark|light)/);
  return m ? m[1] : "dark";
}

export function isPortalDark() {
  return getPortalTheme() === "dark";
}

/**
 * Calls back when the cookie changes. The portal is usually a different tab,
 * so there is no storage event to listen for — re-read when this tab regains
 * focus, which is exactly when the user returns from switching it.
 */
export function onPortalThemeChange(cb) {
  let last = getPortalTheme();
  const check = () => {
    const now = getPortalTheme();
    if (now !== last) { last = now; cb(now); }
  };
  window.addEventListener("focus", check);
  document.addEventListener("visibilitychange", check);
  return () => {
    window.removeEventListener("focus", check);
    document.removeEventListener("visibilitychange", check);
  };
}
